<template>
    <span>
        <table class="layui-hide">
            <slot></slot>
        </table>
        <div class="layui-table-page" style="height:33px;width: 99%;border-width: 0px 1px 1px 1px;margin-bottom: 0px;background: #FFF;" v-if="expandLevel == 1">
            <div class="layui-box layui-laypage layui-laypage-default">
                <a class="layui-laypage-prev" @click="prePage()"
                v-bind:class="{'layui-disabled' : (pageInfo.pageIndex == 1) }">
                    <i class="layui-icon"></i>
                </a>
                <a v-bind:class="{'layui-laypage-curr' : (pIdx == pageInfo.pageIndex)}"
                v-for="pIdx in calPageRange()" v-bind:key="pIdx" @click="toPage(pIdx)" style="cursor: pointer">
                    <em class="layui-laypage-em"></em>
                    <em>{{pIdx}}</em>
                </a>
                <a class="layui-laypage-next" @click="nextPage()"
                    v-bind:class="{'layui-disabled' : (pageInfo.pageIndex == pageInfo.pageTotal) }">
                    <i class="layui-icon"></i>
                </a>
                <span class="layui-laypage-skip">
                    到第<input type="text" class="layui-input" v-model="pageInfo.toPageIndex">页
                    <button type="button" class="layui-laypage-btn" @click="toPage(pageInfo.toPageIndex)">确定</button>
                </span>
                <span class="layui-laypage-count">
                    总 <em v-text="pageInfo.pageTotal"></em> 页,
                    共 <em v-text="pageInfo.totalNum"></em> 条
                </span>
                <span class="layui-laypage-limits">
                    <select @change="pageChange()" v-model="pageInfo.pageSize"  lay-ignore>
                        <option v-for="option in pageInfo.pageOptions" v-bind:key="option" v-bind:value="option" v-text="option + '条/页'"></option>
                    </select>
                </span>
            </div>
        </div>
    </span>
</template>

<script>
export default {
    name: 'LayuiTabletree',
    props: {
        requestUniqueId: {
            type: String, // // 请求唯一标识，必须有
            default: () => {
                return 'layui-tabletree-' + window.uuid();
            },
        },
       // 表名
        tableName: {
            type   : String,
            default: '',
            required: true
        },
        sort: {
            type: Array,
            default: () => {
                return []
            }
        },
        height: {
            type: String,
            default: 'full-320',
        },
        // 默认查询条件，比如state=1， 那么table加载的时候会查询state=1的数据
        // 如果在其他地方设置了关于state的值，那么默认值失效
        defaultCondition: {
            type: Object,
            default: () => {
                return {};
            }
        },
        // 只在初始化的时候执行一次
        onceCondition: {
            type: Object,
            default: () => {
                return {};
            }
        },
        // 要查询的字段，默认查询所有
        selectFields: {
            type   : String,
            default: '',
        },
        pageSize: {
            type   : Number,
        },
        pageRange: {
            type   : Number,
        },
        pageOptions: {
            type: Array,
            default: () => {
                return []
            }
        },
        tableEventPrefix: {
            type: String,
            default: 'tabletree-event-'
        },
        showField: {
            type: String,
            default: 'treeName'
        },
        treeid: {
            type: String,
            default: 'id'
        },
        treepid: {
            type: String,
            default: 'pid'
        },
        jbField: {
            type: String,
            default: 'JB'
        },
        expandLevel: {
            type: Number,
            default: 1
        },
        /**
         * 组件是否用于 layui-body 容器外部
         * - 用于解决弹窗不显示问题
         * - 类型为 DOM 对象或者 JQuery 对象的选择器
         */
        outside: { type: String }
    },
    data: function(){
        return {
            id : null,
            el : null,
            isInit: false,
            data: [],
            checkedRows: [],
            queryObject: {

            },
            pageInfo: {
                pageIndex: 1,
                pageSize: 25,
                pageTotal: 1,
                totalNum: 5,
                pageRange: 8,
                pageOptions: [15, 25, 50, 100]
            },
            _layuiEl : null,
        }
     },
    activated() {
        if(this._layuiEl) {
            this._layuiEl.resize();
        }
    },
    mounted() {
       if(this.pageSize) {
            this.pageInfo.pageSize = this.pageSize;
        }
        if(this.pageRange) {
            this.pageInfo.pageRange = this.pageRange;
        }
        if(this.pageOptions && this.pageOptions.length > 0) {
            this.pageInfo.pageOptions = this.pageOptions;
        }

       var element = this.el = $(this.$el);
       var id = this.id = this.uuid();

        var tableEl = element.find('table');
        tableEl.attr('id', id);
        tableEl.attr('lay-filter', id);
        var table_header_config = [];

        var tr = tableEl.children();
        for(var i = 0 ; i < tr.length; i++) {
            var col = $(tr[i]).children();
            var colConfig = [];
            table_header_config.push(colConfig);
            for(var j = 0 ; j < col.length; j++) {
                var colEl = $(col[j]);
                var field = colEl.attr('field');
                var title = colEl.attr('title');
                var width = colEl.attr('width');
                var align = colEl.attr('align');
                var fixed = colEl.attr('fixed');
                var colspan = colEl.attr('colspan');
                var rowspan = colEl.attr('rowspan');
                var checkbox = colEl.attr('checkbox');
                var toolbar = colEl.attr('toolbar');
                var translateDomain = colEl.attr('translate2');
                var configItem = {};
                if(checkbox == 'true') {
                    configItem.checkbox = true;
                }
                if(title) {
                    configItem.title = title;
                }
                if(field) {
                    configItem.field = field;
                }
                if(align) {
                    configItem.align = align;
                }
                if(fixed) {
                    configItem.fixed = fixed;
                }
                if(colspan) {
                    configItem.colspan = colspan;
                }
                if(rowspan) {
                    configItem.rowspan = rowspan;
                }
                if (width) {
                    configItem.width  = Number(width);
                }
                if(toolbar != undefined) {
                   var toolbarId = 'toolbar-' + this.uuid();
                   colEl.find('script').attr('id', toolbarId);
                   configItem.toolbar = '#' + toolbarId;
                } else {
                    if (colEl.find('script').length > 0) {
                        var templateId = "templateId" + this.uuid();
                        colEl.find('script').attr('id', templateId);
                        configItem.templet = "#" + templateId;
                    }
                }
                colConfig.push(configItem);
            }
        }

        // {field:'aihao', title: '爱好',width:120,event:'aihao',config:{type:'input'},templet:templet }

       var option = {
            elem: '#' + id,
            id: id,
            height: this.height,
            page: false,
            treeConfig: { //表格树所需配置
                showField: this.showField, //表格树显示的字段
                treeid: this.treeid, //treeid所对应字段的值在表格数据中必须是唯一的，且不能为空。
                treepid: this.treepid,//父级id字段名称
                iconClass:'layui-icon-right', //小图标class样式 窗口图标 layui-icon-layer
                showToolbar: false //展示工具栏 false不展示 true展示
            },
            cols: table_header_config,
            data: this.data
       };

       if(this.expandLevel == 1) {
           option.limit = 9999;
       }

       this._layuiEl  = this.layui.tableTree.render(option);


         this.layui.tableTree.on('tool(' + this.id + ')', (obj)=> {
            var field = obj.field; //单元格字段
            var value = obj.value; //修改后的值
            var data = obj.data; //当前行数据
            var event = obj.event; //当前单元格事件
            if(event === 'async'){ //点击方向箭头小图标时触发
                if(!data.childLoaded) {
                    this.loadChild(data);
                } else {
                    // 判断当前节点是展开，还是收缩状态
                    var treeId = data[this.treeid];
                    var curEl = $('[tree-id=' + treeId + ']');
                    var asyncIconEl = curEl.find('.layui-icon-right');
                    if (asyncIconEl.hasClass('layui-tableEdit-clicked')) {
                        // 已经展开，那么久关闭，反之。。
                        this._layuiEl.closeTreeNode(data[this.treeid]);
                    } else {
                        this._layuiEl.openTreeNode(data[this.treeid]);
                    }
                }
            } else {
                this.$emit(this.tableEventPrefix + obj.event,{data: data, layRow: obj});
            }
        });

          this.load();
    },
    methods: {
         getTableName() {
            return this.tableName;
         },
         getTableTreeObj() {
             return this._layuiEl;
         },
         findNodeById(id, dataset, target){
            if(target.length != 1 && dataset) {
                for(var i = 0 ; i < dataset.length; i++) {
                    var curId = dataset[i][this.treeid];
                    if(curId == id) {
                        target[0] = dataset[i];
                        break;
                    }
                    this.findNodeById(id, dataset[i]['treeList'],  target);
                }
            }
        },
        /**
         * "treeName":"系统管理",
         *   "id":"1",
         *   "url":"",
         *   "permissionId ":null,
         *   "sort":"1",
         *   "treeList":[]
         */
        enhance() {
            var point = 1;
            this.data.forEach((e) => {
                e._id = this.id + '-' + (this.pageInfo.pageIndex - 1) * this.pageInfo.pageSize + point;
                e._NUMBER = (this.pageInfo.pageIndex - 1) * this.pageInfo.pageSize + (point++);
            });
        },
        search() {
            this.pageInfo.pageIndex = 1;
            this.load();
        },
        reset () {
            for(var p in this.queryObject) {
                this.queryObject[p] = '';
            }
            this.pageInfo.pageIndex = 1;
            this.load();
        },
        load () {
            this.layer.showLoading({ targetEl: (this.outside && $(this.outside))});
            if(this.expandLevel == 1) {
                 var p2 = $.extend(true, {}, this.defaultCondition, this.queryObject);
                 if(!this.isInit) {
                     this.isInit = true;
                     p2 = $.extend(true, p2, this.onceCondition);
                 }
                 this.api.pageQuery(
                        this.tableName,
                        {p2: p2, p3: this.pageInfo, p9: this.selectFields, p10: this.sort},
                        this.requestUniqueId
                    ).then(response => {
                    this.layer.closeLoading();
                    this.checkedRow = null;
                    this.checkedRows = [];
                    var result = response.result;
                    var records = result.records;
                    this.pageInfo.pageTotal = result.pageInfo.pageTotal;
                    this.pageInfo.totalNum = result.pageInfo.totalNum;
                    this.data = records;
                    for(var j = 0 ; j < this.data.length; j++) {
                        var row = this.data[j];
                        row.childLoaded =  false;
                    }
                    this.enhance();
                    this._layuiEl.getTreeOptions().data = this.data;
                    this._layuiEl.reload();
                });
            } else {
                 var p2 = $.extend(true, {}, this.defaultCondition, this.queryObject);
                  if(!this.isInit) {
                     this.isInit = true;
                     p2 = $.extend(true, p2, this.onceCondition);
                 }
                 this.api.queryList(
                            this.tableName,
                            {p2: p2,  p9: this.selectFields, p10: this.sort},
                            this.requestUniqueId
                        ).then(response => {
                    this.layer.closeLoading();
                    this.checkedRow = null;
                    this.checkedRows = [];
                    var results = response.result;
                    var map = {};
                    var root = [];
                    for(var i = 0 ; i < results.length; i++) {
                        var row = results[i];
                        map[row[this.treeid]] = row;
                    }
                     for(var i = 0 ; i < results.length; i++) {
                        var row = results[i];
                        var parent = null;
                        if((parent = map[row[this.treepid]])) {
                            if(!map[row[this.treepid]]['treeList']){
                                map[row[this.treepid]]['treeList'] = [];
                            }
                            map[row[this.treepid]]['treeList']['push'](row);
                            row._p = true;
                        }
                    }
                     for(var i = 0 ; i < results.length; i++) {
                        var row = results[i];
                        if(!row._p) {
                            root.push(row);
                        }
                     }
                    this.data = root;
                    this._layuiEl.getTreeOptions().data = this.data;
                    this._layuiEl.reload();
                    for(var j = 0 ; j < results.length; j++) {
                        var row = results[j];
                        if(row.treeList && row.treeList.length > 0) {
                            row.childLoaded =  true;
                            this._layuiEl.openTreeNode(row[this.treeid]);
                        }
                    }
                });
            }

        },
        loadChild (data, callback) {
            this.layer.showLoading({ targetEl: (this.outside && $(this.outside))});
            // var p2 = {};
            // loadChild 添加限制条件，仅展示未删除的子集节点
            var p2 = $.extend(true, {}, {NODE_JB: Number(data.NODE_JB) + 1., 'DELETED:0': '0'});
            var pid = data[this.treeid];
            var parent = [];
            this.findNodeById(pid, this.data, parent);
            parent =  parent[0];
            p2[this.treepid] = pid;
            this.api.queryList(
                        this.tableName,
                        {p2: p2,  p9: this.selectFields, p10: this.sort},
                        this.requestUniqueId
                    ).then(response => {
                this.layer.closeLoading();
                var result = response.result;
                if(result){
                     parent.treeList = result;
                     parent.childLoaded = true;
                     parent.expanded = true;
                }
                if(callback){
                     return callback(result)
                }
                this._layuiEl.refresh();
                this._layuiEl.openTreeNode(pid);
            });
        },
        toPage: function(toIdx){
            if(toIdx > 0 && toIdx <= this.pageInfo.pageTotal) {
                this.pageInfo.pageIndex = toIdx;
                this.load();
            }
        },
        calPageRange : function(){
            var pageList = [];
            var diff = 0;
            var range = 0;
            if(!this.pageInfo.pageTotal) return [];
            if(this.pageInfo.pageTotal <= this.pageInfo.pageRange){
                range = this.pageInfo.pageTotal;
            }else{
                range = this.pageInfo.pageRange;
                var curPageIndex = this.pageInfo.pageIndex;
                var half = Math.ceil(this.pageInfo.pageRange / 2) + 1;
                diff = half - curPageIndex >= 0 ? 0 : half - curPageIndex;
            }
            var start = 1 + Math.abs(diff);
            var limit = range + Math.abs(diff);
            if(limit > this.pageInfo.pageTotal){
                limit = this.pageInfo.pageTotal;
                start = start - (this.pageInfo.pageRange + Math.abs(diff) - this.pageInfo.pageTotal);
            }
            for(var i = start ; i <= limit; i++){
                pageList.push(i);
            }
            return pageList;
        },
        prePage: function(){
            if(this.pageInfo.pageIndex > 1){
                this.pageInfo.pageIndex--;
                this.load();
            }
        },
        nextPage: function(){
            if(this.pageInfo.pageIndex <= this.pageInfo.pageTotal - 1){
                this.pageInfo.pageIndex++;
                this.load();
            }
        },
        pageChange: function() {
            this.pageInfo.pageIndex=1;
            this.load();
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/common/LayuiTabletree.vue